// @ts-nocheck

import React, { useEffect, useRef, useState } from 'react';
import styled, { css, keyframes } from 'styled-components';

import theme from '../../../../styled-components/dark';
import { KL_BADGE_HALO_DURATION } from '../../constants/ui';

const haloAnim = keyframes`
  50% {
    opacity: 1;
  }
`;

const Wrapper = styled.div`
  position: relative;
  padding-top: 0.22em;

  padding-left: 1.5em;
  padding-right: 0.6em;
  border-radius: 500em;
  background: #000000aa;

  height: 1.3em;
  border: 1px solid white;

  font-weight: bold;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  ${({ $hasIcon }) => {
    if (!$hasIcon) {
      return css`
        padding-left: 0.6em;
      `;
    }
  }}
  transform-style: preserve-3d;

  ${({ $isPending }) =>
    $isPending
      ? css`
          &:before {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0rem;
            top: 0rem;
            border-radius: 500em;
            box-shadow: 0px 0px 5px 5px #ffd24c;
            transform: translateZ(-100px);
            opacity: 0;
            animation: ${haloAnim} ${KL_BADGE_HALO_DURATION}ms ease-in-out infinite;
          }
        `
      : undefined}
`;

const counterColorAnimation = (color: string) => keyframes`
  0% {
    color: #ffffff;
  }
  100% {
    color: ${color};
  }
`;

const Counter = styled.div`
  transition: color 150ms ease-in-out;

  ${({ $animate, $color }) => css`
    ${$animate &&
    css`
      animation: ${counterColorAnimation($color)} 1s ease;
    `}
    color: ${$color};
  `}
`;

type KLCounterProps = {
  counter: number;
  isPending: boolean;
  Icon?: unknown;
  withTransition?: boolean;
  color?: string;
  className?: string;
};

const KLCounter = ({
  counter,
  isPending,
  Icon,
  withTransition = false,
  className = '',
  color = theme.KLCounter.color,
}: KLCounterProps) => {
  const [hasChangeCounter, setHasChangeCounter] = useState(false);
  const prevCounter = useRef(counter);

  useEffect(() => {
    if (withTransition) {
      setHasChangeCounter(counter !== prevCounter.current);
    }
  }, [withTransition, counter]);

  return (
    <Wrapper className={className} $hasIcon={!!Icon} $isPending={isPending}>
      {Icon ? <Icon /> : null}
      <Counter $animate={hasChangeCounter} $color={color}>
        {counter}
      </Counter>
    </Wrapper>
  );
};

export default KLCounter;
